const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user")({
  beforeLoad: async () => {
    const res = await routeLoaderApiClient.user.$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch user");
    }
    const {
      user
    } = await res.json();
    if (user == null) {
      throw redirect({
        to: "/login",
        search: {
          url: window.location.href
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});